import { ReactFlowInstance, Node, Edge } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditInjectionNode.id)) {
            newNodes.push(node);
        }
    }

    let edges: Edge[] = context.edges;
    let newEdges: Edge[] = [];
    for (const edge of edges) {
        if (!edge.id.includes(context.activeEditInjectionNode.id)) {
            newEdges.push(edge);
        }
    }

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode: Node = context.activeEditInjectionNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes: Node[] = reactFlowInstance.getNodes();
    let newNodes: Node[] = [];
    let activeIds: any[] = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
    ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        value_to_inject: {
            title: 'Data Store',
            type: 'string',
            description: 'Location of the data which will have data injected',
            default: 'default'
        },
        'injections': {
            'title': 'Injections',
            'type': 'array',
            'items': {
                title: '',
                'type': 'object',
                properties: {
                    'data_input': {
                        title: 'Data Input',
                        type: 'string',
                        description: 'Location of data to inject',
                        default: 'default'
                    },
                    input_key: {
                        title: 'Input Key',
                        type: 'string',
                        description: 'Key of data to extract if applicable. Use value_one/value_two for nested data or __END__ for last key',
                    },

                    inject_key: {
                        title: 'Inject Key',
                        type: 'string',
                        description: 'Key of location to inject to. Use value_one/value_two for nested data or __APPEND__ to append or __PREPEND__ to prepend',
                    },
                }
            }
        },
    },
}

export const nodeDescription: string = "This node is used to inject a value into a Data Model or key/value array.\n";

